
{
  "familyId": "TOPO-NL-BUURLANDEN",
  "questions": [
    {
      "id": "TOPO-NL-BUURLANDEN-001",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "multiple_choice",
      "question": "Een vrachtwagenchauffeur wil van Nederland naar een buurland rijden. Welke landen kan hij bereiken zonder eerst door een ander land te rijden?",
      "context": null,
      "options": ["België en Duitsland", "België en Luxemburg", "Duitsland en Polen", "België, Duitsland en Frankrijk"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Buurlanden van Nederland", "content": "Nederland heeft twee buurlanden op het land: België in het zuiden en Duitsland in het oosten. In het noorden en westen ligt de Noordzee.", "icon": "lightbulb"}}],
      "conceptId": "nl_buurlanden_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "topo.buurland-via-buurland", "label": "Verwart Luxemburg (grenst aan België, niet aan NL)", "optionIndex": 1 },
          { "id": "topo.buurland-via-buurland", "label": "Verwart Polen (grenst aan Duitsland, niet aan NL)", "optionIndex": 2 },
          { "id": "topo.buurland-via-buurland", "label": "Verwart Frankrijk (grenst aan België, niet aan NL)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Nederland heeft op het land precies twee buurlanden: België in het zuiden en Duitsland in het oosten. Voor Luxemburg moet je eerst door België; voor Polen eerst door Duitsland; voor Frankrijk ook eerst door België.",
        "solutionSteps": [
          "Een buurland grenst direct aan jouw land",
          "Zuiden: België ✓",
          "Oosten: Duitsland ✓",
          "Noorden en westen: de Noordzee",
          "Antwoord: België en Duitsland"
        ],
        "distractorExplanations": {
          "0": "Goed! Nederland grenst aan België (zuiden) en Duitsland (oosten).",
          "1": "Luxemburg grenst aan België en Duitsland, maar niet aan Nederland. Tussen Nederland en Luxemburg ligt een stuk België.",
          "2": "Polen grenst aan Duitsland, maar niet aan Nederland. Om in Polen te komen rijd je eerst door heel Duitsland.",
          "3": "Frankrijk grenst aan België en Duitsland, maar niet aan Nederland. Voor Frankrijk rijd je eerst door België."
        }
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-002",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "fill_in",
      "question": "Het buurland van Nederland in het oosten is ___. Typ het hele woord.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["Duitsland", "duitsland"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Windrichtingen op de kaart", "content": "Op een kaart is rechts = oosten en onder = zuiden. Rechts van Nederland ligt Duitsland. Onder Nederland ligt België.", "icon": "lightbulb"}}],
      "conceptId": "nl_oost_buurland_fill",
      "variantIndex": 2,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Het buurland in het oosten van Nederland is Duitsland. Op de kaart ligt Duitsland aan de rechterkant van Nederland. België ligt in het zuiden (onder).",
        "solutionSteps": [
          "Op de kaart: rechts = oosten",
          "Rechts van Nederland ligt Duitsland",
          "Antwoord: Duitsland"
        ]
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-003",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "fill_in",
      "question": "De hoofdstad van het zuidelijke buurland van Nederland is ___.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["Brussel", "brussel"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Hoofdstad van België", "content": "Het zuidelijke buurland van Nederland is België. De hoofdstad van België is Brussel. Brussel is óók de plek waar de Europese Unie zijn hoofdkantoor heeft.", "icon": "lightbulb"}}],
      "conceptId": "nl_belgie_hoofdstad_fill",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Het zuidelijke buurland is België. De hoofdstad van België is Brussel. Brussel is ook de hoofdstad van de Europese Unie — daar vergaderen veel Europese leiders.",
        "solutionSteps": [
          "Zuidelijk buurland: België",
          "Hoofdstad van België: Brussel",
          "Antwoord: Brussel"
        ]
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-004",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "matching",
      "question": "Koppel elk land aan zijn hoofdstad.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {"left": "Nederland", "right": "Amsterdam"},
          {"left": "België", "right": "Brussel"},
          {"left": "Duitsland", "right": "Berlijn"},
          {"left": "Luxemburg", "right": "Luxemburg-stad"}
        ]
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Hoofdsteden onthouden", "content": "Nederland → Amsterdam. België → Brussel. Duitsland → Berlijn. Luxemburg → Luxemburg-stad (de stad heeft dezelfde naam als het land).", "icon": "lightbulb"}}],
      "conceptId": "buurlanden_hoofdsteden_matching",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Nederland → Amsterdam. België → Brussel. Duitsland → Berlijn. Luxemburg → Luxemburg-stad. Let op: Luxemburg is een land én een stad met dezelfde naam.",
        "solutionSteps": [
          "Nederland → Amsterdam (hoofdstad)",
          "België → Brussel (ook hoofdstad EU)",
          "Duitsland → Berlijn",
          "Luxemburg → Luxemburg-stad"
        ]
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-005",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "true_false_series",
      "question": "Beoordeel elke stelling over de buurlanden van Nederland.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "Nederland grenst aan België in het zuiden.", "isTrue": true },
          { "text": "Nederland grenst aan Frankrijk.", "isTrue": false },
          { "text": "Berlijn is de hoofdstad van Duitsland.", "isTrue": true },
          { "text": "Nederland heeft drie buurlanden op het land.", "isTrue": false },
          { "text": "Tussen Nederland en Luxemburg ligt een stuk België.", "isTrue": true }
        ]
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Feiten over de buurlanden", "content": "Nederland heeft 2 buurlanden: België (zuiden) en Duitsland (oosten). Frankrijk grenst aan België, niet aan Nederland. Luxemburg ligt onder België, niet onder Nederland.", "icon": "lightbulb"}}],
      "conceptId": "nl_buurlanden_tf",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Nederland grenst aan België (zuiden) ✓ en aan Duitsland (oosten). Frankrijk grenst NIET aan Nederland ✗. Berlijn is inderdaad de hoofdstad van Duitsland ✓. Nederland heeft maar 2 buurlanden, niet 3 ✗. Luxemburg grenst aan België, niet aan Nederland ✓.",
        "solutionSteps": [
          "België in zuiden → WAAR",
          "Frankrijk grenst niet aan NL → ONWAAR",
          "Berlijn = hoofdstad Duitsland → WAAR",
          "NL heeft 2 buurlanden, geen 3 → ONWAAR",
          "België ligt tussen NL en Luxemburg → WAAR"
        ]
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-006",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "categorize",
      "question": "In welke categorie hoort elke plaats: een buurland van Nederland, een hoofdstad van een buurland, of geen buurland?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Buurland van NL", "Hoofdstad van een buurland", "Geen buurland van NL"],
        "items": [
          { "text": "België", "correctCategory": 0 },
          { "text": "Duitsland", "correctCategory": 0 },
          { "text": "Berlijn", "correctCategory": 1 },
          { "text": "Brussel", "correctCategory": 1 },
          { "text": "Frankrijk", "correctCategory": 2 },
          { "text": "Luxemburg", "correctCategory": 2 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Buurlanden, hoofdsteden en de rest", "content": "Buurlanden van NL: België en Duitsland. Hoofdsteden daarvan: Brussel en Berlijn. Frankrijk en Luxemburg liggen verder weg — zij grenzen aan België of Duitsland, maar niet aan Nederland.", "icon": "lightbulb"}}],
      "conceptId": "buurlanden_categorize",
      "variantIndex": 6,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "België en Duitsland zijn de twee buurlanden van Nederland. Brussel en Berlijn zijn hun hoofdsteden. Frankrijk en Luxemburg zijn wél buurlanden van België of Duitsland, maar niet van Nederland.",
        "solutionSteps": [
          "België → buurland NL ✓",
          "Duitsland → buurland NL ✓",
          "Berlijn → hoofdstad Duitsland",
          "Brussel → hoofdstad België",
          "Frankrijk → buurland van België, niet van NL",
          "Luxemburg → buurland van België, niet van NL"
        ]
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-007",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "multiple_choice",
      "question": "Een leerling tekent een kaart en zet een pijl van Nederland naar het oosten. In welke richting wijst die pijl op de kaart?",
      "context": null,
      "options": ["Naar rechts", "Naar links", "Naar boven", "Naar beneden"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Windrichtingen op de kaart", "content": "Op een kaart geldt: boven = noorden, onder = zuiden, rechts = oosten, links = westen. Het buurland in het oosten (Duitsland) ligt dus rechts op de kaart.", "icon": "lightbulb"}}],
      "conceptId": "windstreken_kaart_oost",
      "variantIndex": 7,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "topo.windstreken-omgedraaid", "label": "Verwart oost met west (links)", "optionIndex": 1 },
          { "id": "topo.windstreken-omgedraaid", "label": "Verwart oost met noord (boven)", "optionIndex": 2 },
          { "id": "topo.windstreken-omgedraaid", "label": "Verwart oost met zuid (onder)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Op een kaart wijst oost naar rechts. Onthoud: NOZW = Noord (boven), Oost (rechts), Zuid (onder), West (links). Duitsland ligt dus rechts van Nederland op de kaart.",
        "solutionSteps": [
          "Boven = noord, rechts = oost, onder = zuid, links = west",
          "Oost wijst naar rechts",
          "Antwoord: naar rechts"
        ],
        "distractorExplanations": {
          "0": "Goed! Oost = rechts op de kaart.",
          "1": "Links = west, niet oost. Ezelsbruggetje: 'NOZW' — Oost komt na Noord, dus rechts.",
          "2": "Boven = noord, niet oost. Het noorden ligt boven op de kaart.",
          "3": "Onder = zuid, niet oost. Onthoud: rechts = oost."
        }
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-008",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "fill_in",
      "question": "Een wandelaar loopt vanuit Maastricht een paar kilometer naar het zuiden. In welk land komt zij dan? Typ de naam.",
      "context": "Maastricht ligt in de provincie Limburg, helemaal in het zuiden van Nederland.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["België", "belgië", "belgie"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Maastricht en de grens", "content": "Maastricht ligt in Limburg, in het uiterste zuiden van Nederland. Vanuit Maastricht ben je binnen een paar kilometer in België.", "icon": "lightbulb"}}],
      "conceptId": "context_maastricht_grens",
      "variantIndex": 8,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Maastricht ligt heel dicht bij de grens met België. Wie vanuit Maastricht naar het zuiden loopt, komt binnen een paar kilometer in België. Duitsland ligt in het oosten van Limburg, niet in het zuiden.",
        "solutionSteps": [
          "Maastricht ligt in het zuiden van Limburg",
          "Naar het zuiden = richting België",
          "Antwoord: België"
        ]
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-009",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "multiple_choice",
      "question": "Welke uitspraak over de buurlanden van Nederland klopt?",
      "context": null,
      "options": [
        "Duitsland heeft een veel grotere oppervlakte dan Nederland.",
        "België is groter dan Duitsland.",
        "Nederland is het grootste land van de drie.",
        "België en Duitsland hebben precies dezelfde grootte."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Oppervlakte van de drie landen", "content": "Duitsland is veruit het grootst (~357.000 km²). Nederland is klein (~42.000 km²). België is nog wat kleiner dan Nederland (~30.500 km²). Duitsland is dus ruim 8× groter dan Nederland.", "icon": "lightbulb"}}],
      "conceptId": "buurlanden_oppervlakte_vergelijken",
      "variantIndex": 9,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "topo.land-grootte-verward", "label": "Denkt dat België groter is dan Duitsland", "optionIndex": 1 },
          { "id": "topo.land-grootte-verward", "label": "Denkt dat Nederland het grootst is", "optionIndex": 2 },
          { "id": "topo.land-grootte-verward", "label": "Denkt dat alle landen even groot zijn", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Duitsland is veel groter dan Nederland en België: ongeveer 357.000 km² tegenover 42.000 km² (NL) en 30.500 km² (BE). Op de kaart zie je dat goed: Duitsland beslaat een groot deel van Midden-Europa.",
        "solutionSteps": [
          "Duitsland: ~357.000 km² (veruit het grootst)",
          "Nederland: ~42.000 km²",
          "België: ~30.500 km² (kleinst van de drie)",
          "Volgorde groot → klein: Duitsland, Nederland, België"
        ],
        "distractorExplanations": {
          "0": "Goed! Duitsland is veel groter dan Nederland — ongeveer 8× zo groot.",
          "1": "België is juist iets kléiner dan Nederland en veel kleiner dan Duitsland.",
          "2": "Nederland is een klein land vergeleken met Duitsland. Duitsland is veruit het grootst.",
          "3": "De drie landen verschillen sterk in grootte. Duitsland is veruit het grootst."
        }
      }
    },
    {
      "id": "TOPO-NL-BUURLANDEN-010",
      "familyId": "TOPO-NL-BUURLANDEN",
      "module": "Topo",
      "tier": 4,
      "levelCode": "M6+",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_buurlanden",
      "questionType": "ordering",
      "question": "Zet deze landen op volgorde: van het noorden naar het zuiden in Europa.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["Frankrijk", "Nederland", "België", "Duitsland"],
        "correctOrder": [1, 3, 2, 0]
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Noord-zuid op de kaart", "content": "Nederland ligt het meest noordelijk van deze vier. Daaronder Duitsland (in het westelijke deel) en België. Frankrijk ligt nóg verder zuidelijk en grenst aan België.", "icon": "lightbulb"}}],
      "conceptId": "buurlanden_noord_zuid_ordering",
      "variantIndex": 10,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Van noord naar zuid: Nederland → Duitsland (het deel direct ten oosten van NL) → België (ten zuiden van NL) → Frankrijk (ten zuiden van België). Let op: Duitsland is een groot land — het westelijke deel ligt op dezelfde hoogte als Nederland en België, maar op deze schaal zetten we het tussen Nederland en België in.",
        "solutionSteps": [
          "Meest noordelijk: Nederland",
          "Daarna: Duitsland (oosten van NL, gemiddeld iets zuidelijker)",
          "Dan: België (ten zuiden van NL)",
          "Meest zuidelijk: Frankrijk",
          "Volgorde: Nederland → Duitsland → België → Frankrijk"
        ]
      }
    }
  ]
}
